import {Navigate} from 'react-router'
import {DEFAULT_AUTHENTICATED_ROUTE} from '../../routing/constants'

const DashboardPage = () => {
  return <Navigate to={DEFAULT_AUTHENTICATED_ROUTE} replace />
}

export {DashboardPage}
